import { useState } from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import FormBuilder from "./formbuilder";
import FormBuilderField from "./FormBuilderField";

export default function ShiftChangeOrverConfigIndex({ embedded = false } = {}) {
  const [isOpenFieldModal, setIsOpenFieldModal] = useState(false);

  const toggleFieldModal = () => setIsOpenFieldModal((prev) => !prev);

  const inner = (
    <>
      <div className="px-4 sm:px-6 lg:px-8 py-5 bg-[#f7fafa] text-[#181c1d] min-h-screen">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-[#08757C] tracking-tight">
          Shift Change Over — Form Builder
        </h2>
        <p className="text-[#3e494a] mt-2 max-w-xl text-sm mb-5">
          Drag field types onto the canvas to design what outgoing and
          incoming officers fill in during a shift handover.
        </p>

        <FormBuilder toggleFieldModal={toggleFieldModal} />
      </div>

      {isOpenFieldModal && (
        <>
          <div
            className="fixed inset-0 bg-black/40 backdrop-blur-[3px] z-[200]"
            onClick={toggleFieldModal}
          />
          <div className="fixed inset-0 z-[210] flex items-center justify-center p-4">
            <div
              className="bg-white rounded-3xl shadow-2xl w-full max-w-lg max-h-[85vh] flex flex-col overflow-hidden"
              style={{ animation: "fadeUp 0.25s cubic-bezier(0.4,0,0.2,1)" }}
            >
              <style>{`@keyframes fadeUp{from{transform:translateY(20px);opacity:0}to{transform:translateY(0);opacity:1}}`}</style>

              {/* Header — same shell as the runtime Shift Change Over popup
                  (ShiftChangeOverForm.js): gradient header, icon badge,
                  eyebrow + title, close button. */}
              <div
                className="px-7 py-5 flex items-center justify-between flex-shrink-0"
                style={{ background: "linear-gradient(135deg,#08757C,#0a9aa3)" }}
              >
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-xl bg-white/20 flex items-center justify-center flex-shrink-0">
                    <span className="material-symbols-outlined text-white text-[22px]">
                      edit_note
                    </span>
                  </div>
                  <div>
                    <p className="text-white/60 text-xs font-semibold uppercase tracking-widest mb-0.5">
                      Form Field
                    </p>
                    <h3
                      className="text-base font-black text-white"
                      style={{ fontFamily: "Manrope, sans-serif" }}
                    >
                      Edit Field
                    </h3>
                  </div>
                </div>
                <button
                  onClick={toggleFieldModal}
                  className="h-9 w-9 flex items-center justify-center rounded-xl bg-white/10 hover:bg-white/20 text-white transition-colors flex-shrink-0"
                >
                  <span className="material-symbols-outlined text-[20px]">
                    close
                  </span>
                </button>
              </div>

              {/* Body + footer live inside FormBuilderField so its own
                  handleSubmit/state stay put — only the shell moved. */}
              <FormBuilderField toggleFieldModal={toggleFieldModal} />
            </div>
          </div>
        </>
      )}
    </>
  );

  return embedded ? inner : <DashboardLayout>{inner}</DashboardLayout>;
}
